import { Component, FunctionalComponent } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import Tooltip from '@insided/deprecated-control/ui-components/Tooltip'
import Button from '@insided/control/uikit/Button'

interface CopyToClipboardButtonProps {
    onCopyHandler: () => void
}

interface CopyToClipboardState {
    isCopied: boolean
}

interface CopyToClipboardProps {
    text: string
}

const CopyToClipboardButton: FunctionalComponent<CopyToClipboardButtonProps> = ({ onCopyHandler }) =>
  <Button icon='copy' onClick={onCopyHandler} variant='text' className='copy-to-clipboard__button' />

class CopyToClipboard extends Component<CopyToClipboardProps, CopyToClipboardState> {
    constructor () {
        super()
        this.state = {
            isCopied: false
        }
        this.onCopyHandler = this.onCopyHandler.bind(this)
    }

    onCopyHandler(text: string) {
        navigator.clipboard.writeText(text)
            .then(() => {
                this.setState({ isCopied: true })
                setTimeout(() => {
                    this.setState({ isCopied: false })
                }, 1500)
            })
            .catch((err) => {
                console.error(err)
            })
    }

    render() {
        const { text } = this.props
        const { isCopied } = this.state
        return (
          <Tooltip
            noWrap
            tooltipMessage={isCopied ? 'Copied' : ''}
            customClasses={['copy-to-clipboard__tooltip', isCopied ? 'show' : undefined].join(' ')}
            trigger={<CopyToClipboardButton onCopyHandler={() => this.onCopyHandler(text)} />}
          />
        )
    }
}

export default CopyToClipboard
